import { InputPinCode, Loading, PopupWraper } from 'components';
import { Button, InputWraper, useForm } from 'modules';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useCheckPinCodeMutation } from 'services';

import { formSchema } from './config';

type Props = {
  isOpen: boolean;
  isLoadingProcess?: boolean;
  onSuccess: ({ pinCode }: { pinCode: string }) => void;
  onClose: () => void;
};

const ModalConfirm = (props: Props) => {
  const { isOpen, onSuccess, onClose, isLoadingProcess = false } = props;

  const [isShowPopup, setIsShowPopup] = useState<boolean>(isOpen);

  const { mutateAsync, isLoading } = useCheckPinCodeMutation();

  const { handleSubmit: handleSubmitModal, getInputProps: getInputPropsModal } =
    useForm({
      structure: formSchema,
      onSubmit: handleCheckPinCode,
    });

  useEffect(() => {
    setIsShowPopup(isOpen);
  }, [isOpen]);

  async function handleCheckPinCode(values: any) {
    const { pinCode } = values;

    try {
      const dataCheckPinCode = await mutateAsync({ pinCode });

      if (dataCheckPinCode && dataCheckPinCode?.isValid) {
        // toast.success("Xác thực thành công");

        return onSuccess({ pinCode });
      }

      throw dataCheckPinCode;
    } catch (error: any) {
      console.error(error);
      toast.error(String(error?.message) || 'Xác thực không thành công');
    }
  }

  if (!isShowPopup) return <></>;

  return (
    <PopupWraper
      center
      title='Nhập mật khẩu'
      onClose={() => {
        setIsShowPopup(false);
        onClose();
      }}
    >
      <form onSubmit={handleSubmitModal} className='charge-bill-container'>
        <Loading isLoading={isLoading || isLoadingProcess}>
          <div className='charge-bill__title'>
            <InputWraper
              label='Mật khẩu'
              inputProps={getInputPropsModal('pinCode')}
              component={InputPinCode}
            />
          </div>
          <div className='charge-bill__button-container'>
            <Button
              className='button__confirm mr5'
              label='Xác nhận'
              buttonType='success'
              type='submit'
            />
            <Button
              className='button__cancel ml5'
              onClick={() => {
                setIsShowPopup(false);
                onClose();
              }}
              label='Trở về'
              buttonType='primary-outline'
            />
          </div>
        </Loading>
      </form>
    </PopupWraper>
  );
};

export default ModalConfirm;
